/**
 * Under-13 deferred — v1 launch posture (22a) informational screen.
 *
 * Shown when an under-13 DoB hits the age gate while
 * `features.under13PlayerAccounts === false` (v1 default). No
 * account is created, no consent flow runs.
 *
 * Mirrors apps/mobile/app/(auth)/under-13-deferred.tsx tone for
 * cross-platform consistency.
 */
import { Button } from './primitives';
import './AuthGate.css';

export function Under13Deferred() {
  const handleBack = () => {
    // Hard reload to /  — clears any stale Supabase session in memory.
    window.location.href = '/';
  };

  return (
    <div className="auth-gate">
      <div className="auth-gate__panel">
        <h1 className="auth-gate__brand">4CM</h1>
        <h2 className="auth-gate__heading">You&apos;ll be on the pitch soon</h2>
        <p className="auth-gate__copy">
          Right now 4CM is for players aged 13 and over. We&apos;re opening up
          to younger players soon — until then, your coach can still use 4CM
          for your whole team.
        </p>
        <ul className="auth-gate__bullets">
          <li>Your coach can plan your sessions and track your development on 4CM.</li>
          <li>If you have a parent on 4CM, they can see your coach&apos;s notes.</li>
          <li>When we open up to your age group, we&apos;ll invite you to claim your own account.</li>
        </ul>
        <Button variant="primary" size="touchline" onClick={handleBack}>
          Back to sign in
        </Button>
      </div>
    </div>
  );
}
